import { useEffect, useState } from "react";

const KEY = "fhp-simple";
const EVT = "simple-changed";

export const isSimple = () => { try { return localStorage.getItem(KEY) !== "0"; } catch { return true; } };

export function setSimple(on) {
  try { localStorage.setItem(KEY, on ? "1" : "0"); } catch { /* private mode */ }
  window.dispatchEvent(new Event(EVT));
}

export function useSimple() {
  const [on, setOn] = useState(isSimple);
  useEffect(() => {
    const sync = () => setOn(isSimple());
    window.addEventListener(EVT, sync);
    return () => window.removeEventListener(EVT, sync);
  }, []);
  return on;
}
